import { render, staticRenderFns } from "./BackgroundColorControl.vue?vue&type=template&id=f291a96e"
import script from "./BackgroundColorControl.vue?vue&type=script&lang=js"
export * from "./BackgroundColorControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports